import { DsTypography } from '@pulsepointinc/design-system-react';
import type { CSSProperties } from 'react';
import MaintenanceIcon from '../assets/svg/maintenance.svg';

const styles: Record<string, CSSProperties> = {
  wrapper: {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '60px',
  },
};

export interface ErrorOverlayProps {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  error?: Error;
}

export const ErrorOverlay: React.FC<ErrorOverlayProps> = ({
  icon = <MaintenanceIcon />,
  title = null,
  subtitle = null,
  error = null,
}) => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        {icon}

        <div>
          {typeof title === 'string' ? <DsTypography align="center">{title}</DsTypography> : title}

          {typeof subtitle === 'string' ? <DsTypography align="center">{subtitle}</DsTypography> : subtitle}
        </div>

        {!!error && (
          <pre>
            {error?.message}
            {'\n\n'}
            {error?.stack}
          </pre>
        )}
      </div>
    </div>
  );
};
